const clientFields = {
  clienteTipo: 'tipo_cliente', codiceFiscale: 'codice_fiscale', dataNascita: 'data_nascita',
  luogoNascita: 'luogo_nascita', natoEstero: 'nato_estero', statoNascita: 'stato_nascita',
  ragioneSociale: 'ragione_sociale', partitaIva: 'partita_iva',
  codiceFiscaleAzienda: 'codice_fiscale_azienda', sedeLegale: 'sede_legale',
  telefonoWhatsapp: 'telefono_whatsapp', emailsExtra: 'emails_extra', telefoniExtra: 'telefoni_extra'
};
const accidentFields = {
  dataMessaInMora: 'data_messa_in_mora', dataSinistro: 'data_sinistro', oraSinistro: 'ora_sinistro', luogoSinistro: 'luogo_sinistro', scadenzaPrescrizione: 'scadenza_prescrizione',
  autoritaPresenti: 'autorita_presenti', autoritaIntervenuta: 'autorita_intervenuta',
  cittaAutorita: 'citta_autorita', responsabilitaControparte: 'responsabilita_controparte',
  numeroPolizza: 'numero_polizza', contraentePolizza: 'contraente_polizza',
  garanzieInteressate: 'garanzie_interessate', franchigiaPolizza: 'franchigia_polizza'
};
export const medicalSections = ['prontoSoccorso', 'visiteMediche', 'esamiStrumentali', 'cartelleCliniche', 'terapie', 'medicinaliAltro'];
const readFields = (data, fields) => ({ ...data, ...Object.fromEntries(Object.entries(fields)
  .map(([form, stored]) => [form, data[stored] ?? data[form] ?? ''])) });
const writeFields = (data, fields) => {
  const result = { ...data };
  Object.entries(fields).forEach(([form, stored]) => { result[stored] = data[form]; delete result[form]; });
  return result;
};
export const readSuspendedClient = data => ({ ...readFields(data, clientFields),
  clienteTipo: data.tipo_cliente || data.clienteTipo || 'fisica',
  emailsExtra: data.emails_extra || data.emailsExtra || [],
  telefoniExtra: data.telefoni_extra || data.telefoniExtra || []
});
export const writeSuspendedClient = data => writeFields(data, clientFields);
export const readSuspendedAccident = data => ({ ...readFields(data, accidentFields), mezzi: data.mezzi || [] });
export const writeSuspendedAccident = data => writeFields(data, accidentFields);
export const readSuspendedMedical = data => {
  const result = { ...data, ...Object.fromEntries(medicalSections.map(section => [section, data[section] || []])) };
  const legacyTypes = { 'Pronto soccorso': 'prontoSoccorso', 'Visita medica': 'visiteMediche',
    'Esame strumentale': 'esamiStrumentali', 'Cartella clinica': 'cartelleCliniche', 'Terapia': 'terapie' };
  (data.voci || []).forEach((item, index) => {
    const section = legacyTypes[item.tipo] || 'visiteMediche';
    result[section] = [...result[section], { id: `legacy-${index}`, values: {
      Data: item.data || '', Descrizione: item.descrizione || '', Note: item.tipo || ''
    } }];
  });
  delete result.voci;
  return result;
};
